import router from '@/router'
import {appStates, isSharedState} from '@/constants'
import {getBuyoutId, setBuyoutId} from '@/composables/context'

const needRedirect = () => {
  return !isSharedState(router.history.current.name)
}

const toBuyoutItemState = (sourceId, buyoutId) => {
  if (getBuyoutId() !== buyoutId) {
    router.replace({
      name: appStates.sourceItemBuyoutItem.name,
      params: {sourceId: sourceId, buyoutId: buyoutId}
    })
      .then(setBuyoutId(buyoutId))
  }
}

const toSourceListState = () => {
  router.replace({name: appStates.sourceList.name})
}

const toSourceState = sourceId => {
  router.replace({
    name: appStates.sourceItemContent.name,
    params: {sourceId: sourceId}
  })
}
 
export {
  needRedirect,
  toBuyoutItemState,
  toSourceListState,
  toSourceState
}